export default __webpack_public_path__ + "static/media/CascadeFallsMap.a40629b1.jpg";